var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.625C13.8995 13.625 16.25 11.2745 16.25 8.375C16.25 5.4755 13.8995 3.125 11 3.125C8.1005 3.125 5.75 5.4755 5.75 8.375C5.75 11.2745 8.1005 13.625 11 13.625Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04199 18.218C3.84882 16.8214 5.00895 15.6618 6.40583 14.8556C7.80272 14.0494 9.38717 13.625 11 13.625C12.6129 13.625 14.1973 14.0495 15.5942 14.8557C16.991 15.662 18.1512 16.8216 18.958 18.2181",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.81e85bf9679d6fa3a071e6f8d2e9f14a.svg";
export { ForwardRef as ReactComponent };